/* Search Overlay — machuPICyou Predictive Search */

(function () {
  'use strict';

  var overlay, input, results, viewAll, status;
  var searchUrl, noResultsTpl, minCharsMsg;
  var controller = null;
  var debounceTimer = null;
  var triggerBtn = null;

  function init() {
    overlay = document.getElementById('search-overlay');
    if (!overlay) return;

    input = overlay.querySelector('[data-search-input]');
    results = overlay.querySelector('[data-search-results]');
    viewAll = overlay.querySelector('[data-search-view-all]');
    status = overlay.querySelector('[data-search-status]');

    searchUrl = overlay.getAttribute('data-search-url') || '/search';
    noResultsTpl = overlay.getAttribute('data-no-results') || '';
    minCharsMsg = overlay.getAttribute('data-min-chars') || '';

    // Open triggers
    document.querySelectorAll('[data-search-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        triggerBtn = btn;
        openSearch();
      });
    });

    // Close triggers
    overlay.querySelectorAll('[data-search-close]').forEach(function (el) {
      el.addEventListener('click', closeSearch);
    });

    // Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.getAttribute('aria-hidden') === 'false') {
        closeSearch();
      }
    });

    // Input handler
    input.addEventListener('input', function () {
      var query = input.value.trim();
      clearTimeout(debounceTimer);

      if (query.length < 2) {
        clearResults();
        if (query.length > 0) {
          status.textContent = minCharsMsg;
        } else {
          status.textContent = '';
        }
        return;
      }

      debounceTimer = setTimeout(function () {
        fetchResults(query);
      }, 300);
    });

    // Keyboard navigation in results
    results.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      e.preventDefault();

      var links = results.querySelectorAll('.search-result');
      if (!links.length) return;

      var current = document.activeElement;
      var idx = Array.prototype.indexOf.call(links, current);

      if (e.key === 'ArrowDown') {
        idx = idx < links.length - 1 ? idx + 1 : 0;
      } else {
        idx = idx > 0 ? idx - 1 : links.length - 1;
      }
      links[idx].focus();
    });

    // Arrow down from input goes to first result
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        var first = results.querySelector('.search-result');
        if (first) {
          e.preventDefault();
          first.focus();
        }
      }
      // Enter goes to search page
      if (e.key === 'Enter' && input.value.trim().length >= 2) {
        e.preventDefault();
        window.location.href = searchUrl + '?q=' + encodeURIComponent(input.value.trim()) + '&type=product';
      }
    });
  }

  function openSearch() {
    // Close mobile menu if open
    var nav = document.querySelector('.nav-menu');
    if (nav && nav.classList.contains('is-open')) {
      nav.classList.remove('is-open');
    }

    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    input.value = '';
    clearResults();
    status.textContent = '';

    setTimeout(function () {
      input.focus();
    }, 50);
  }

  function closeSearch() {
    overlay.setAttribute('aria-hidden', 'true');

    // Only restore scroll if mobile menu is not open
    var nav = document.querySelector('.nav-menu');
    if (!nav || !nav.classList.contains('is-open')) {
      document.body.style.overflow = '';
    }

    if (triggerBtn) {
      triggerBtn.focus();
      triggerBtn = null;
    }
  }

  function clearResults() {
    results.innerHTML = '';
    viewAll.style.display = 'none';
  }

  function fetchResults(query) {
    // Cancel previous request
    if (controller) controller.abort();
    controller = new AbortController();

    var url = searchUrl + '/suggest.json?q=' + encodeURIComponent(query)
      + '&resources[type]=product'
      + '&resources[limit]=6'
      + '&resources[options][unavailable_products]=hide';

    fetch(url, { signal: controller.signal })
      .then(function (resp) { return resp.json(); })
      .then(function (data) {
        var products = [];
        if (data && data.resources && data.resources.results && data.resources.results.products) {
          products = data.resources.results.products;
        }
        renderResults(products, query);
      })
      .catch(function (err) {
        if (err.name !== 'AbortError') {
          console.error('Search error:', err);
          status.textContent = '';
        }
      });
  }

  function renderResults(products, query) {
    results.innerHTML = '';
    status.textContent = '';

    if (!products.length) {
      status.textContent = noResultsTpl.replace('__TERMS__', query);
      viewAll.style.display = 'none';
      return;
    }

    products.forEach(function (product) {
      var a = document.createElement('a');
      a.href = product.url;
      a.className = 'search-result';
      a.tabIndex = 0;

      // Thumbnail
      var img = document.createElement('img');
      img.className = 'search-result__image';
      img.alt = product.title;
      img.loading = 'lazy';
      img.width = 56;
      img.height = 56;
      if (product.image) {
        // Shopify CDN resize
        img.src = product.image.replace(/\.([a-z]+)(\?|$)/, '_120x120_crop_center.$1$2');
      } else if (product.featured_image && product.featured_image.url) {
        img.src = product.featured_image.url;
      } else {
        img.src = '';
      }
      a.appendChild(img);

      // Info
      var info = document.createElement('div');
      info.className = 'search-result__info';

      var title = document.createElement('p');
      title.className = 'search-result__title';
      // Remove region prefix duplication: "Berlin — Berlin Love" → "Berlin Love"
      var displayTitle = product.title;
      if (displayTitle.indexOf(' — ') > -1) {
        displayTitle = displayTitle.split(' — ').pop();
      }
      title.textContent = displayTitle;
      info.appendChild(title);

      var price = document.createElement('p');
      price.className = 'search-result__price';
      var rawPrice = product.price;
      if (typeof rawPrice === 'string' && rawPrice.indexOf('.') > -1) {
        price.textContent = rawPrice.replace('.', ',') + ' €';
      } else if (typeof rawPrice === 'number') {
        price.textContent = (rawPrice / 100).toFixed(2).replace('.', ',') + ' €';
      } else {
        price.textContent = rawPrice || '';
      }
      info.appendChild(price);

      a.appendChild(info);
      results.appendChild(a);
    });

    // Update view all link
    viewAll.href = searchUrl + '?q=' + encodeURIComponent(query) + '&type=product';
    viewAll.style.display = 'block';
  }

  document.addEventListener('DOMContentLoaded', init);
})();
